// VRG-712 — Analytics → Website's tabs, kept pure (no React) so the tab ↔ URL contract can be
// pinned by `test/website-analytics-tabs.guard.spec.ts` with node's own test runner.

export const WEBSITE_TABS = ['overview', 'live', 'visitors', 'links'] as const
export type WebsiteTab = (typeof WEBSITE_TABS)[number]

/** Visitor history and Tracked links show emails and per-person links: platform admins only. */
export const ADMIN_ONLY_TABS: ReadonlySet<WebsiteTab> = new Set(['visitors', 'links'])

/** Tabs whose figures the date range cuts. Live is "right now" and ignores it. */
export const RANGED_TABS: ReadonlySet<WebsiteTab> = new Set(['overview', 'visitors', 'links'])

/**
 * `?tab=` → the tab to show. Anything unknown, missing, or a tab this viewer may not see falls
 * back to Overview rather than to an empty panel. (`seo` and `affiliates` never reach here:
 * `legacyAnalyticsTabTarget` redirects them first.)
 */
export const websiteTabFrom = (raw: string | null, isPlatformAdmin: boolean): WebsiteTab => {
  const tab = (WEBSITE_TABS as readonly string[]).includes(raw ?? '') ? (raw as WebsiteTab) : 'overview'
  return ADMIN_ONLY_TABS.has(tab) && !isPlatformAdmin ? 'overview' : tab
}
